import {NgModule} from "@angular/core";
import {ExportTableComponent} from "./export-table.component";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatTableModule} from "@angular/material/table";
import {CommonModule} from "@angular/common";
import {MatInputModule} from "@angular/material/input";
import {MatPaginatorModule} from "@angular/material/paginator";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormatDatePipeModule} from "@app/pipes/format-date/format-date-pipe.module";
import {MatSortModule} from "@angular/material/sort";
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
    declarations:[ExportTableComponent],
    imports: [
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatTableModule,
        CommonModule,
        MatInputModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        FormsModule,
        FormatDatePipeModule,
        MatSortModule,
        MatDialogModule
    ],
    exports:[ExportTableComponent]
})
export class ExportTableModule { }
